import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { requestPublicJson } from '../../services/api.js';

// Preserve filters reached through tag links without introducing another search box.
export default function BusinessTagFilter() {
  const [params, setParams] = useSearchParams();
  const idsKey = params.get('tagIds') || '';
  const ids = idsKey.split(',').filter(Boolean);
  const [selected, setSelected] = useState([]);
  useEffect(() => {
    let active = true;
    setSelected([]);
    if (idsKey) requestPublicJson(`/api/business-tags?${new URLSearchParams({ ids: idsKey })}`)
      .then(data => { if (active) setSelected(data.tags || []); })
      .catch(() => { /* Filters remain removable even if labels cannot be loaded. */ });
    return () => { active = false; };
  }, [idsKey]);
  const update = nextIds => {
    const next = new URLSearchParams(params);
    if (nextIds.length) next.set('tagIds', nextIds.join(','));
    else { next.delete('tagIds'); next.delete('matchMode'); }
    next.delete('page');
    setParams(next);
  };
  if (!ids.length) return null;
  return <section className="mb-3 flex flex-wrap items-center gap-2" aria-label="Active public tag filters">
    <span className="text-sm text-base-content/70">{params.get('matchMode') === 'ALL' ? 'All tags:' : 'Tags:'}</span>
    {ids.map(id => {
      const name = selected.find(tag => tag.id === id)?.name || 'Unavailable tag';
      return <button className="rounded border px-3 py-2 text-sm" key={id} type="button" aria-label={`Remove filter ${name}`} onClick={() => update(ids.filter(value => value !== id))}>{name} ×</button>;
    })}
    <button type="button" className="text-sm underline" onClick={() => update([])}>Clear tag filters</button>
  </section>;
}
